import classNames from 'classnames';
import VibeIcon from '../../VibeIcon/VibeIcon';
import * as color from '../../../sass/color.scss';

function IconCell({
  className = '',
  rowId = null,
  icon,
  color = color.primary,
  hoverColor = color.secondary,
  size = 24,
  tooltip = null,
  tooltipProps = {},
  onClick = null,
}) {
  return (
    <div
      className={classNames('IconCell', className)}
      style={{
        textAlign: 'center',
      }}
    >
      <VibeIcon
        name={rowId}
        icon={icon}
        color={color}
        hoverColor={onClick
          ? hoverColor
          : null}
        size={size}
        tooltip={tooltip}
        tooltipProps={tooltipProps}
        onClick={onClick}
      />
    </div>
  );
}

export default IconCell;
